module.exports = __webpack_public_path__ + "img/tywin_TF_wordcloud.23a8aec0.png";